var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import Body from 'syf-component-library/ui/typography/Body';
import { formatDisplayDate } from 'syf-js-utilities';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { CERTIFICATE_HISTORY, PageType } from '../../../../../const/analytics';
import { useRewardsConfigContext } from '../../../../../context/rewardsConfig';
import { sortByDate } from '../../../../../helpers/certificateHistoryUtils';
import useRewards from '../../../../../hooks/useRewards';
import useRewardsAnalytics from '../../../../../hooks/useRewardsAnalytics';
import RewardBanner from '../../../../../ui/atoms/RewardBanner';
import CertificateStatusTag from '../../atoms/CertificateStatusTag';
import InputSearch from '../../atoms/InputSearch';
import SelectDropdown from '../../atoms/SelectDropdown';
import ShopMore from '../../molecules/ShopMore';
import CertificateHistory from './CertificateHistory';
import { filterRedeemedOrExpired } from './helpers';
import { CertificateAmount, CertificateHistoryContainer, CertificateHistorySeparator, EmptyCertificateHistoryContainer, EmptyCertificateHistoryTextWrapper, HeaderWrapper, RewardBannerContainer, SelectTopBorder } from './subcomponents';
var CertificateHistoryTab = function () {
    var _a, _b, _c, _d;
    var config = useRewardsConfigContext().config;
    var _e = useRewards(), cardType = _e.cardType, certificates = _e.certificates, hasCertificateHistory = _e.hasCertificateHistory, allRewardsCertificate = _e.allRewardsCertificate, rewardsExperience = _e.rewardsExperience, clientId = _e.clientId;
    var _f = useWindowSize(), isLessThanDesktop = _f.isLessThanDesktop, isLessThanMobile = _f.isLessThanMobile;
    var filteredRedeemedOrExpired = useMemo(function () { return filterRedeemedOrExpired(certificates.certificateDetails); }, [certificates]);
    var _g = useState(sortByDate(filteredRedeemedOrExpired, 'desc') || []), certificateDetails = _g[0], setCertificateDetails = _g[1];
    var _h = useState(''), certificateNumSearch = _h[0], setCertificateNumSearch = _h[1];
    var _j = useState({
        sortFunction: sortByDate,
        direction: 'desc'
    }), sortSelection = _j[0], setSortSelection = _j[1];
    var mappedCertificates = useMemo(function () {
        return certificateDetails.map(function (certDetails) { return [
            _jsx(Body, __assign({ isInline: true, weight: "semiBold" }, { children: formatDisplayDate(certDetails.certificateStatus === 'EXPIRED'
                    ? certDetails.certificateExpiryDate
                    : certDetails.certificateStatusDate) })),
            certDetails === null || certDetails === void 0 ? void 0 : certDetails.certificateNumber,
            {
                value: (_jsx(CertificateStatusTag, { certificateStatus: certDetails === null || certDetails === void 0 ? void 0 : certDetails.certificateStatus })),
                align: 'left'
            },
            {
                value: (_jsxs(CertificateAmount, { children: ["$", certDetails === null || certDetails === void 0 ? void 0 : certDetails.certificateIssuedAmount] })),
                align: 'right'
            }
        ]; });
    }, [certificateDetails]);
    var onSelectOptionClick = function (certificateList) {
        var sortedCerts = filterRedeemedOrExpired(sortSelection.sortFunction(__spreadArray([], certificateList, true), sortSelection.direction));
        setCertificateDetails(sortedCerts);
    };
    useRewardsAnalytics({
        allRewardsCertificate: allRewardsCertificate,
        pageSubFunction: CERTIFICATE_HISTORY,
        clientName: clientId,
        pageType: PageType.CertificateTab
    });
    /** Handles the debounced filtering */
    useEffect(function () {
        var debounceTimer = setTimeout(function () {
            if (filteredRedeemedOrExpired) {
                var searchFilteredCertificates = filteredRedeemedOrExpired.filter(function (cert) { return cert.certificateNumber.includes(certificateNumSearch); });
                onSelectOptionClick(searchFilteredCertificates);
            }
        }, 500);
        return function () { return clearTimeout(debounceTimer); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [certificateNumSearch, filteredRedeemedOrExpired]);
    var onChange = function (e) {
        var value = e.target.value;
        setCertificateNumSearch(value);
    };
    var defaultBanner = (_b = (_a = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _a === void 0 ? void 0 : _a[cardType]) === null || _b === void 0 ? void 0 : _b.certificateHistoryImg;
    var mobileBanner = (_d = (_c = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _c === void 0 ? void 0 : _c[cardType]) === null || _d === void 0 ? void 0 : _d.certificateHistoryImgSm;
    var banner = isLessThanMobile && mobileBanner ? mobileBanner : defaultBanner;
    return (_jsx(CertificateHistoryContainer, { children: hasCertificateHistory && Boolean(filteredRedeemedOrExpired.length) ? (_jsxs(_Fragment, { children: [_jsxs(HeaderWrapper, { children: [_jsx(InputSearch, { onChange: onChange, value: certificateNumSearch }), isLessThanDesktop && _jsx(SelectTopBorder, {}), _jsx(SelectDropdown, { certificateDetails: certificateDetails, setSortSelection: setSortSelection, onSelectOptionClick: onSelectOptionClick })] }), _jsx(CertificateHistory, { certificateDetails: certificateDetails, mappedCertificates: mappedCertificates, config: config }), _jsx(RewardBannerContainer, { children: banner && _jsx(RewardBanner, { client: clientId, image: banner }) })] })) : (_jsxs(EmptyCertificateHistoryContainer, { children: [_jsx(EmptyCertificateHistoryTextWrapper, { children: _jsx(ShopMore, { className: "certificates-page" }) }), _jsx(CertificateHistorySeparator, {}), _jsx(RewardBannerContainer, __assign({ className: "empty-certificate-history-banner" }, { children: banner && (_jsx(RewardBanner, { client: clientId, image: banner, className: "certificates-page" })) }))] })) }));
};
export default CertificateHistoryTab;
